// Polyfill pour les attributs command et commandfor
// * https://developer.chrome.com/blog/command-and-commandfor?hl=fr
// * https://developer.mozilla.org/en-US/docs/Web/API/HTMLButtonElement/command
// * https://developer.mozilla.org/en-US/docs/Web/API/HTMLButtonElement/commandForElement

let abortControl = null;

function unbindCommandButtons() {
    if (abortControl) {
        abortControl.abort();
        abortControl = null;
    }
}

function clickHandler(event) {
    const source = event.target.closest('button');
    const command = source.getAttribute('command');
    const commandfor = source.getAttribute('commandfor');
    const target = document.getElementById(commandfor);
    if (!target) return;
    switch (command) {
        case 'show-modal': {
            target.showModal?.();
            break;
        }
        case 'request-close': {
            target.requestClose?.();
            break;
        }
        case 'close': {
            target.close?.();
            break;
        }
        case 'show-popover': {
            target.showPopover?.();
            break;
        }
        case 'hide-popover': {
            target.hidePopover?.();
            break;
        }
        case 'toggle-popover': {
            target.togglePopover?.();
            break;
        }
        default: {
            if (command.startsWith('--')) {
                target.dispatchEvent(new CommandEvent({ command, source }));
            }
        }
    }
}

function bindCommandButton(button, signal) {
    button.addEventListener('click', clickHandler, { signal });
}

function bindCommandButtons() {
    abortControl = new AbortController;
    const commandButtons = document.querySelectorAll('button[commandfor][command]');
    for (const button of commandButtons) {
        bindCommandButton(button, abortControl.signal);
    }
}

function initCommandButtons() {
    unbindCommandButtons();
    bindCommandButtons();
}

window.addEventListener('load', () => {
    if (window.CommandEvent) return; // Check if Command API is available

    window.CommandEvent = class CommandEvent extends Event {
        #options;

        constructor(options = { }) {
            super('command', options);
            this.#options = options;
        }

        get source() {
            return this.#options.source;
        }

        get command() {
            return this.#options.command;
        }
    }

    const mutationObserver = new MutationObserver((mutations) => {
        let rebind = false;
        for (const mutation of mutations) {
            if (mutation.type === 'attributes') {
                rebind = true;
            }
        }
        if (rebind) initCommandButtons();
    })
    mutationObserver.observe(document.body, {
        attributes: [ 'command', 'commandfor' ],
        subtree: true
    });

    initCommandButtons();
});